<template>
  <div class="mt-6 container-fluid">
      <div class="col-12">
        <h3 class="text-center py-4 mb-0">New Upload</h3>
        <div class="d-flex justify-content-center align-items-center" style="min-height: 55vh;">
          <div class="card w-100" style="max-width: 600px;">
            <div class="card-body">
              <form>
                <media class="js-active position-relative" />
              </form>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import setNavPills from "@/assets/js/nav-pills.js";
import Media from "./Media.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "UploadFile",
  components: {
    Media
  },
  computed: {
    ...mapGetters("files", ["isLoadingUpload"]),
    ...mapGetters("user", ["userDetails"])
  },
  async mounted() {
    setNavPills();
    this.populateUserDetails();
  },
  methods: {
    ...mapActions("user", ["populateUserDetails"])
  },

};
</script>